// removed by extract-text-webpack-plugin
module.exports = {"content":"_-src-components-IndexRoute-styles---content---3T8i8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexRoute/styles.css
// module id = 803
// module chunks = 0